import MaskDirectLogin from '../../src/legacy/MaskDirectLogin.tsx';
export default MaskDirectLogin;
